import * as types from "./actionTypes";

export const showSqftTooltip = ({
                                  title = '',
                                  description = '',
                                  icon = null,
                                  position = 'right',
                                  targetRect
                                }) => ({
  type: types.SHOW_SQFT_TOOLTIP,
  payload: {
    title,
    description,
    icon,
    position,
    targetRect,
    isVisible: true
  }
});

export const hideSqftTooltip = () => ({
  type: types.HIDE_SQFT_TOOLTIP,
  payload: {
    isVisible: false
  }
});
